import React, { FC, useCallback } from 'react';
import { Button } from '@src/atoms/Button';
import { ILegoElemButton } from '../models';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import type { ILegoElemProps } from '../../Lego';

export const LegoElemButton: FC<ILegoElemProps> = ({ elem, loading, isMobile }) => {
  const { formHook } = useLegoFormContext();
  // const value = formHook.watch(elem.id);
  const buttonElem = elem as ILegoElemButton;

  const handleButtonOnClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      buttonElem.button.onClick?.(e);

      if (buttonElem.submitWithValue) {
        // для заполнения пропуска шага визарда.
        // Когда надо пропустить валидацию шага, но
        // сохранить инфу, что она была пропущена
        formHook.setValueAndRevalidate(elem.id, true);
      }
      if (buttonElem.submitNoValidation) {
        formHook.submitForm(formHook.getValues());
      }
    },
    [buttonElem.submitNoValidation, buttonElem.submitWithValue, buttonElem.button, elem.id, formHook],
  );

  return (
    <Button
      fullWidth={isMobile}
      {...buttonElem.button}
      loading={loading}
      disabled={buttonElem.button.disabled || loading}
      onClick={handleButtonOnClick}
    >
      {buttonElem.content || 'Отправить'}
    </Button>
  );
};
